import React from 'react'
import { Tooltip } from '../Tooltip'

export default function AutosaveTooltip(props) {
  return <Tooltip placement="bottom-end" leaveDelay={300} arrow {...props} />
}
